import React, { useEffect, useRef, useState } from 'react'
import { Route, Routes, useNavigate } from 'react-router-dom'
import { Security, LoginCallback, useOktaAuth } from '@okta/okta-react'
import { OktaAuth, toRelativeUrl } from '@okta/okta-auth-js'
import Home from './Home'
import Login from './Login'
import Templates from './Templates'
import Permissions from './Permissions'
import AliasUserManagement from './alias-user-management/AliasUserManagement'
import CreateOrganization from './CreateOrganization'
import { withNavBar } from '../components/reuseable/withNavBar'
import { oktaAuthConfig, oktaSignInConfig } from '../okta_config'
console.log(oktaAuthConfig)

const oktaAuth = new OktaAuth(oktaAuthConfig)

/** Same behavior as @okta/okta-react SecureRoute, inlined for react-router v6+ (no useRouteMatch). */
function Protected({ children }) {
  const { oktaAuth: auth, authState, _onAuthRequired } = useOktaAuth()
  const pendingLogin = useRef(false)
  const [loginError, setLoginError] = useState(null)

  useEffect(() => {
    const handleLogin = async () => {
      if (pendingLogin.current) return
      pendingLogin.current = true
      auth.setOriginalUri(toRelativeUrl(window.location.href, globalThis.location.origin))
      if (_onAuthRequired) await _onAuthRequired(auth)
      else await auth.signInWithRedirect()
    }

    if (!authState) return

    if (authState.isAuthenticated) {
      pendingLogin.current = false
      return
    }

    handleLogin().catch((err) => setLoginError(err))
  }, [authState, auth, _onAuthRequired])

  if (loginError) {
    const msg = loginError?.name && loginError?.message
      ? `${loginError.name}: ${loginError.message}`
      : String(loginError)
    return <p>{msg}</p>
  }

  if (!authState || !authState.isAuthenticated) return null
  return children
}

const AppWithRouterAccess = () => {
  const navigate = useNavigate()

  const customAuthHandler = () => {
    navigate('/login')
  }

  const restoreOriginalUri = async (_oktaAuth, originalUri) => {
    navigate(toRelativeUrl(originalUri, globalThis.location.origin), { replace: true })
  }

  return (
    <Security
      oktaAuth={oktaAuth}
      onAuthRequired={customAuthHandler}
      restoreOriginalUri={restoreOriginalUri}
      className='security'
    >
      <div className="switch">
        <Routes>
          <Route path="/login/callback" element={<LoginCallback />} />
          <Route path="/login" element={<Login config={oktaSignInConfig} />} />
          <Route path="/" element={<Protected>{React.createElement(withNavBar(Home))}</Protected>} />
          <Route path="/templates" element={<Protected>{React.createElement(withNavBar(Templates))}</Protected>} />
          <Route path="/permissions" element={<Protected>{React.createElement(withNavBar(Permissions))}</Protected>} />
          <Route path="/alias-user-management" element={<Protected>{React.createElement(withNavBar(AliasUserManagement))}</Protected>} />
          <Route path="/create-org" element={<Protected>{React.createElement(withNavBar(CreateOrganization))}</Protected>} />
        </Routes>
      </div>
    </Security>
  )
}
export default AppWithRouterAccess
